'use strict';

module.exports = {
    algorithm: 'algorithm',
    override: 'override',
    reference: 'reference',
};
